import React from 'react';

export interface RoleInfoCellProps {
  displayName: string;
  name: string;
  color?: string | null;
}

export const RoleInfoCell: React.FC<RoleInfoCellProps> = ({
  displayName,
  name,
  color
}) => {
  return (
    <div className="flex items-center space-x-3">
      {color && (
        <div 
          className="w-4 h-4 rounded-full border border-border-primary"
          style={{ backgroundColor: color }}
        />
      )}
      <div className="flex flex-col">
        <div className="text-sm font-medium text-text-primary">
          {displayName}
        </div>
        <code className="text-xs text-text-secondary">
          {name}
        </code>
      </div>
    </div>
  );
};
